<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Información del Impuesto">
          <b-table class="datos-objeto" 
              responsive="sm" 
              :busy="tableBusy"
              :items="proveedorDatos" 
              :fields="fields">
            <template v-slot:cell(valor)="data">
              {{ formattedData(data.item) }}
            </template>
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
          </b-table>
        </b-card>
      </b-col>
    </b-row>
    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item @click.stop="editar">
            <i class="fa fa-edit"></i>Editar Datos del Impuesto</b-dropdown-item>
          <b-dropdown-item @click.stop="goBack">
            <i class="fa fa-undo"></i>Volver al Listado</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import { createHelpers } from 'vuex-map-fields';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'

const { mapFields } = createHelpers({
  getterType: 'proveedor/getField',
  mutationType: 'proveedor/updateField',
});

export default {
  name: 'ImpuestoDatos',
  components: {
    appMensaje: Mensaje,
  },
  mixins: [
    msjModal, 
  ],
  data: () => {
    return {
      id: 0,

      fields: [
        {key: 'campo'},
        {key: 'valor'},
      ],

      tableBusy: false,

    }
  },
  computed: {
    ...mapFields([
      'proveedorDatos',
    ]),
  },  
  created() {
    this.id= this.$route.params.id

    this.tableBusy = true;
    this.$store.dispatch('proveedor/getProveedorDatos', this.id)
      .then(() => this.tableBusy = false)
      .catch(error => this.showErrorMsj(error));
  },  
  methods: {
    goBack() {
      // this.$router.go(-1);
      this.$router.push({ name: 'Impuestos' });
    },
    editar() {
      this.$router.push({ name: 'ImpuestoABM', 
                          params: { id: this.id }});
    },
  }
}
</script>
